// extracted by mini-css-extract-plugin
module.exports = {"header-bg-image":"i","headerBgImage":"i","header-bg":"j","headerBg":"j"};